
import Vue from "vue";
import {SaleRow} from "@/models/base";
import {SaleEditState} from "@/utils/sale-edit/sale-edit-state";
import {roundTo8Decimals} from "@/utils/numbers";

export default Vue.extend({
	data(){
		return {
			row: new SaleRow()
		};
	},
	props: {
		amount: {
			type: Number,
			required: false
		},
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	methods: {
		changeVat(vat:number){
			this.row.Vat = vat;
			this.row.ProductDescription = this.$ct("description").toString() +" "+ this.row.Vat + "%";
			this.recalculate();
		},
		cancel(){
			this.$emit("close");
		},
		recalculate(){
			this.row.TotalPriceExcVat = this.row.TotalPriceIncVat/(1+(this.row.Vat/100));
			this.row.UnitPrice = roundTo8Decimals(this.row.TotalPriceExcVat / (this.row.Amount * (1 - this.row.Discount / 100)));
			this.row.calculateTotals(this.state.sale);
		},
		save(){
			this.recalculate();
			this.row.calculateTotals(this.state.sale);
			this.state.sale.Rows.push(this.row);
			this.state.sale.calculateTotals();
			this.$emit("close");
		}
	},
	mounted(){
		this.changeVat(21);
		this.row.TotalPriceIncVat = this.amount;
		this.row.ProductDescription = this.$ct("description").toString() +" "+ this.row.Vat + "%";
		this.recalculate();
	},
	components: {

	},
	i18nEx: {
		componentPrefix: "components.sales.Cashier"
	},
});
